import { EndCustomerServiceInterface, EndCustomerFormValues, APIClientInterface, EndCustomer, ListResponse, SingleResponse } from '../types'

export default class EndCustomerService implements EndCustomerServiceInterface {
	constructor(private client: APIClientInterface) {}

	public async search(value: string): Promise<ListResponse<EndCustomer>> {
		return this.client.get(`/endcustomers?q=${value}`)
	}

	public async getAll(): Promise<ListResponse<EndCustomer>> {
		return this.client.get(`/endcustomers`)
	}

	public async getById(id: number): Promise<SingleResponse<EndCustomer>> {
		return this.client.get(`/endcustomers/${id}`)
	}

	public async delete(id: number): Promise<void> {
		return this.client.delete(`/endcustomers/${id}`)
	}

	public async edit(id: number, values: EndCustomerFormValues): Promise<SingleResponse<EndCustomer>> {
		return this.client.patch(`/endcustomers/${id}`, JSON.stringify(values))
	}

	public async create(values: EndCustomerFormValues): Promise<SingleResponse<EndCustomer>> {
		return this.client.post(`/endcustomers`, JSON.stringify(values))
	}
}
